import React from 'react'
import { FormControl, Button, Table, Collapse, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { getColourClassStatus } from '../../../utils/cssgetter'
import { getCsvDataForAllTransactions, getCsvDataForSingleTransaction, getCsvFileName } from '../../../utils/csvdatagetter'
import { enumvaluetranslations } from '../../../utils/enumvaluetranslations'
import { parseFloatCurrency } from '../../../utils/formatting/floatnumberparsing'
import { getCorrectionNumbers, getSizeEntries, getSizeNumbers, getTotal } from '../../../utils/tableparser'
import { RenderImage } from '../../images/ImageView'
import { DescriptionTooltipView } from '../../_reusedcomponents/DescriptionTooltipView'
import { ExportCSV } from '../../_reusedcomponents/ExportCSVView'
import { MainComponentHeaderView } from '../../_reusedcomponents/MainComponentHeaderView'

/**
 * View for Header of IncomingTransactions. Uses Composition with TransactionHeaderView.
 * The Button opens a new empty mask to enter transaction
 * @param {any} handleShowMaskDelivery handles visibility of transaction mask
 * @param {any} handleSearchInput sets a new string value if input changes
 * @param {any} setFilterbar passed hook for setting the table-internal filter nemu on or off
 * @param {any} filteredIncomingTransactions passed incoming transactions with filtering already applied
 * */
const IncomingTransactionsHeaderView = ({ handleSearchInput, setFilterbar, filteredIncomingTransactions, filterArticles, toggleFilterArticles }) => {
    return (
        <>
            <MainComponentHeaderView title={window.i18n('inbox')} filteredElements={filteredIncomingTransactions} fileName={window.i18n('incoming_transactions')} handleSearchInput={handleSearchInput} setFilterbar={setFilterbar} getCsvData={getCsvDataForAllTransactions} showExportButton={false} filterArticles={filterArticles} toggleFilterArticles={toggleFilterArticles}>
            </MainComponentHeaderView>
        </>
    )
}

/**
 * View for the table of IncomingTransactions. Lists transaction as main row and the linked articles in a Collapse-Component.
 * @param {any} filteredIncomingTransactions array with passed incoming transactions with filtering already applied
 * @param {any} sortTransaction handles sorting of transactions
 * @param {boolean} filterable bool to check wheter filter menu is expanded
 * @param {object} DateSelect component for selecting a date
 * @param {object} StateSelect component fpr selecting a value from a given list
 * @param {any} expandRow expands or collapses a row
 * @param {any} getIsExpandedRow returns a bool whether the row to check is expanded or not
 * @param {any} updateTransactionDraft opens a modal for updating a transaction draft, calls a fetch
 * @param {any} removeTransactionDraft removes a transaction draft from the list, calls a fetch
 * @param {any} handleShowConfirmationModal handles the visibility of a modal for corrections
 * @param {object[]} corrections old correction values already saved
 * @param {object[]} newCorrections new correction datas set by user inputs
 * @param {any} openCorrectionLine opens a new line to set correction values for article types
 * @param {object[]} correctionColor new correction datas set by user inputs
 * @param {any} addNewCorrectionForArticleType adds a correction for an articleType via user input
 * */
const IncomingTransactionsTableView = ({ filteredIncomingTransactions, filterable, expandRow, getIsExpandedRow, sortTransaction, DateSelect, StateSelect, handleShowConfirmationModal,
    openCorrectionLine, correctionColor, newCorrections, corrections, addNewCorrectionForArticleType, getCorrectionInputFields, getNewCorrectionValues }) => {

    const getTotalTotal = (articleTypes) => {
        let numbersTotal = 0
        articleTypes.forEach(x => {
            let numbers = x.Sizes.map(entry => parseInt(entry.Amount))
            let total = 0
            numbers.map(number => total = parseInt(total) + parseInt(number))

            numbersTotal += total
        })

        return numbersTotal
    }

    return (
        <div>
            <div className="tablet-transactions-scroll">
                <Table className="articletype-table table-sm table-striped-immediate ">
                    <thead className="sticky-table-header">
                        <th></th>
                        <th className="mainColumn">{window.i18n('deliverySource')}
                            <a href="" className="sort-link" onClick={(e) => sortTransaction(e, 'DeliveryFrom')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">{window.i18n('creationDate')}
                            <a href="" className="sort-link" onClick={(e) => sortTransaction(e, 'Date')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">{window.i18n('state')}
                            <a href="" className="sort-link" onClick={(e) => sortTransaction(e, 'State')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">{window.i18n('remark')}
                            <a href="" className="sort-link" onClick={(e) => sortTransaction(e, 'Remark')}>&#8593; &#8595;</a>
                        </th>
                        <th></th>
                    </thead>
                    {filterable ? <thead>
                        <th></th><th></th>
                        <th>{DateSelect}</th>
                        <th>{StateSelect}</th>
                        <th></th>
                        <th></th>
                    </thead> : null}
                    <tbody>
                        {filteredIncomingTransactions.map((transaction) =>
                            <>
                                <tr className="salesboutique-mainrow" onClick={(e) => expandRow(e, transaction.TransactionSysId)} aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}>
                                    {getIsExpandedRow(transaction.TransactionSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                                    <td>{transaction.SourceOrTargetName}</td>
                                    <td>{transaction.CreationDate}</td>
                                    <td className={getColourClassStatus(transaction.State)}>{enumvaluetranslations(transaction.State)}</td>
                                    <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltipView(transaction.Remark)}>
                                        <td className="remark-td">{transaction.Remark}</td>
                                    </OverlayTrigger>
                                    <td></td>
                                </tr>

                                
                                    <Collapse in={getIsExpandedRow(transaction.TransactionSysId)} timeout={30}>
                                        <td colSpan="6" className="td-nomargin">
                                        <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                            {[...new Set(transaction.Articles.map(article => article.SizeCat))].map(sizeCat =>
                                                <>
                                                <thead className="sticky-table-header">
                                                    <tr className="salesboutique-childheaderrow">
                                                        <th className="imageColumn"></th>
                                                        <th>{window.i18n('articleNumber')}
                                                        </th>
                                                        <th>{sizeCat}
                                                        </th>
                                                        <th>{window.i18n('colour')}
                                                        </th>
                                                        <th className="numberColumn">{window.i18n('salePriceAbb')}
                                                        </th>
                                                        {getSizeEntries(transaction.Articles.find(x => x.SizeCat === sizeCat).Sizes)}
                                                        <th className="numberColumn">Total
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                {transaction.Articles.sort((a, b) => a.Name.localeCompare(b.Name))
                                                    .filter(x => x.SizeCat === sizeCat).map(article =>
                                                        <>
                                                            <tr>
                                                                <td className="imageColumn">{RenderImage(article.Image)}</td>
                                                                <td>{article.ArticleIdFaex}</td>
                                                                <td>{article.Name}</td>
                                                                <td>{article.Colour}</td>
                                                                <td className="numberColumn">{parseFloatCurrency(article.SalePrice)}</td>
                                                                {getSizeNumbers(article.Sizes)}
                                                                {getTotal(article.Sizes)}

                                                                {transaction.State == "InProcess" ?
                                                                    <td>
                                                                        <OverlayTrigger placement="bottom" overlay={<Tooltip> {window.i18n('addCorrection')} </Tooltip>}>
                                                                            <Button className="button-mar" size="sm" variant="secondary" onClick={() => openCorrectionLine(transaction.TransactionSysId, article.ArticleTypeSysId)}>&#9998;</Button>
                                                                        </OverlayTrigger>
                                                                    </td>
                                                                    : null}
                                                            </tr>

                                                            {article.CorrectedArticles == true ?
                                                                <tr className={correctionColor(transaction.State)}>
                                                                    <td></td>
                                                                    <td>{window.i18n('correction')}</td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    {getCorrectionNumbers(article.Sizes)}
                                                                </tr>
                                                                : null}

                                                            {newCorrections.includes(transaction.TransactionSysId + "__" + article.ArticleTypeSysId) == true ?
                                                                <tr className="correction-corrected">
                                                                    <td className="new-correction">{window.i18n('newCorrection') + ":"}</td>
                                                                    <td />
                                                                    <td />
                                                                    <td></td>
                                                                    <td></td>
                                                                    {getNewCorrectionValues(article.Sizes)}

                                                                </tr>
                                                                : null}

                                                            {corrections.includes(transaction.TransactionSysId + "__" + article.ArticleTypeSysId) == true ?
                                                                <tr>
                                                                    <td />
                                                                    <td />
                                                                    <td />
                                                                    <td></td>
                                                                    <td></td>
                                                                    {getCorrectionInputFields(transaction.TransactionSysId, article.ArticleTypeSysId, article.Sizes)}
                                                                    <td />
                                                                    <td>
                                                                        <OverlayTrigger placement="bottom" overlay={<Tooltip> {window.i18n('submitCorrection')} </Tooltip>}>
                                                                            <Button className="button-mar" size="sm" variant="secondary" onClick={() => addNewCorrectionForArticleType(transaction.TransactionSysId, article.ArticleTypeSysId, article.Sizes, article)}>&#10003;</Button>
                                                                        </OverlayTrigger>
                                                                    </td>
                                                                </tr>
                                                                : null}

                                                        </>
                                                        )}

                                                        <tr className="stockReport-row">
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>{window.i18n('sum') + ":"} </td>
                                                            <td>{getTotalTotal(transaction.Articles)}</td>
                                                        </tr>
                                                    </tbody>
                                                </>
                                            )}
                                        </div>

                                        {transaction.StateCorrected == "_corrected" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State, true)}>{window.i18n('submitCorrection')}</Button></td>
                                            </tr>
                                            : null}

                                        {(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "InProcess" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>{window.i18n('submitDelivery')} &#10003;</Button></td>
                                            </tr>
                                            : null}

                                        {(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "InTransit" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>{window.i18n('submitDeliveryIncome')} &#10003;</Button></td>
                                            </tr>
                                            : null}

                                        {(transaction.StateCorrected == "" || transaction.StateCorrected == undefined) && transaction.State == "Arrived" ?
                                            <tr>
                                                <td></td>
                                                <td><Button variant="secondary" size="sm" onClick={() => handleShowConfirmationModal(transaction.TransactionSysId, transaction.State)}>{window.i18n('submitEditing')} &#10003;</Button></td>
                                            </tr>
                                            : null}

                                        <tr>
                                            <td></td>
                                            <td><ExportCSV  disabled={false} csvData={getCsvDataForSingleTransaction(transaction.Articles, [...new Set(transaction.Articles.map(article => article.SizeCat))])} fileName={getCsvFileName(transaction.CreationDate, "_" + window.i18n('deliveryTarget') + "_", transaction.SourceOrTargetName)} isTransaction={true} /></td>
                                        </tr>

                                        </td>
                                    </Collapse>
                            </>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export { IncomingTransactionsHeaderView, IncomingTransactionsTableView }